import {useQuery} from "@tanstack/react-query";

import {useGetHasPermissions} from "@/src/modules/core/store/me";

import {
  VEHICLE_CATALOG_SEARCH_MIN_CHARS,
  vehicleCatalogMakeItems,
} from "../lib/vehicle-catalog-search";
import {vehiclesService} from "../services";

export {VEHICLE_CATALOG_SEARCH_MIN_CHARS as VEHICLE_MAKE_SEARCH_MIN_CHARS};

/**
 * Server-backed make search (`GET vehiclemake?filter[name]=…`). Requires ≥2 characters.
 */
export function useVehicleMakesSearch(searchText: string) {
  const getHasPermission = useGetHasPermissions();
  const catalogEnabled =
    getHasPermission("vehicle store") ||
    getHasPermission("vehicle update") ||
    getHasPermission("companyvehicle store") ||
    getHasPermission("companyvehicle update");

  const q = searchText.trim().slice(0, 150);
  const enabled = catalogEnabled && q.length >= VEHICLE_CATALOG_SEARCH_MIN_CHARS;

  const query = useQuery({
    queryKey: ["vehicle-makes", "search", q],
    queryFn: () => vehiclesService.searchVehicleMakes(q),
    enabled,
    retry: false,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    ...query,
    items: vehicleCatalogMakeItems(searchText, query.data),
  };
}
